import { render, staticRenderFns } from "./modalDatos.vue?vue&type=template&id=f62f98e8&scoped=true"
import script from "./modalDatos.vue?vue&type=script&lang=js"
export * from "./modalDatos.vue?vue&type=script&lang=js"
import style0 from "./modalDatos.vue?vue&type=style&index=0&id=f62f98e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f98e8",
  null
  
)

export default component.exports